<ng-template #contentHeaderTemplate></ng-template>

<app-table id="dashboard.administration.users.index"></app-table>
